<template>
  <div>
    <div class="position-relative">
      <section class="section-shaped my-0">
          <div class="shape shape-style-1 shape-default shape-skew bg-gradient-warning bg-image-imac">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
          <div class="container shape-container d-flex">
            <div class="col px-0">
              <div class="row">
                <div class="col-lg-7">
                  <h1 class="display-3 text-white">{{ $t('resume.header') }}</h1>
                  <p class="lead  text-white">{{ $t('resume.title') }}</p>
                </div>
              </div>
            </div>
          </div>
      </section>
    </div>
    <section class="section section-lg pt-lg-0 mt--200">
        <div class="container">
            <div class="row row-grid align-items-center">
                <div class="col-md-6">
                    <div class="card bg-default shadow border-0">
                        <img v-lazy="'/img/tiles/coach.png'" class="card-img-top" alt="Two men using computers">
                        <blockquote class="card-blockquote">
                            <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 583 95"
                                  class="svg-bg">
                                <polygon points="0,52 583,95 0,95" class="fill-default"></polygon>
                                <polygon points="0,42 583,95 683,0 0,95" opacity=".2" class="fill-default"></polygon>
                            </svg>
                            <h4 class="display-3 font-weight-bold text-white">{{ $t('resume.tile') }}</h4>
                        </blockquote>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="pl-md-5">
                      <h3>{{ $t('resume.title2') }}</h3>
                        <p class="lead">{{ $t('resume.para1') }}</p>
                        <p>{{ $t('resume.para2') }}</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="section section-lg pt-0">
        <div class="container">
            <card gradient="warning"
                  no-body
                  shadow-size="lg"
                  class="border-0">
                <div class="p-5">
                    <div class="row align-items-center">
                        <div class="col-lg-8">
                          <h3 class="text-white">{{ $t('resume.title3') }}</h3>
                          <p class="lead text-white mt-3">{{ $t('resume.block') }}</p>
                        </div>
                        <div class="col-lg-3 ml-lg-auto">
                          <base-button
                            tag="a"
                            href="http://www.africau.edu/images/default/sample.pdf"
                            type="white"
                            block
                            size="lg">
                            {{ $t('resume.buttonDownload') }}
                          </base-button>
                        </div>
                    </div>
                </div>
            </card>
        </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "resume"
};
</script>